import { render } from "./RoleManage.vue?vue&type=template&id=e11d1540&ts=true"
import script from "./RoleManage.vue?vue&type=script&lang=ts"
export * from "./RoleManage.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/zhongyue/Desktop/work/hu-shop/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__